import * as React from 'react';
import { OutsideClick, Popup, PopupArrow } from '@cian/components';
import { IGetOfferDataResponseSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IPageData } from '../../store';
import { IconFacebook, IconOk, IconSharing, IconTwitter, IconVk } from './icons';
import { trackClickOnSharingButton, trackClickOnSharingMainButton } from './tracking';
import * as styles from './index.css';
import { getGeoLabel } from '../../utils/meta/partials/getGeoLabel';

export interface ISharingProps {
  offerData: IGetOfferDataResponseSchema;
  pageData: IPageData;
  title: string;
}

export interface ISharingState {
  isOpenPopup: boolean;
}

export class Sharing extends React.Component<ISharingProps, ISharingState> {
  private input: HTMLInputElement | null;

  public state = {
    isOpenPopup: false,
  };

  public render() {
    const { pageData } = this.props;

    return (
      <div className={styles['container']}>
        <div className={styles['sharing_button']} onClick={this.handleClickOnSharingMainButton} title="Поделиться">
          <IconSharing />
          {this.state.isOpenPopup && (
            <OutsideClick rootElement={<div />} onOutsideClick={this.closePopup}>
              <Popup arrow={PopupArrow.CENTER} containerStyle={styles['popup']}>
                <div className={styles['social_row']}>
                  <div className={styles['vk']} onClick={e => this.handleSocialLink(e, 'vk')}>
                    <IconVk />
                  </div>
                  <div className={styles['ok']} onClick={e => this.handleSocialLink(e, 'ok')}>
                    <IconOk />
                  </div>
                  <div className={styles['facebook']} onClick={e => this.handleSocialLink(e, 'facebook')}>
                    <IconFacebook />
                  </div>
                  <div className={styles['twitter']} onClick={e => this.handleSocialLink(e, 'twitter')}>
                    <IconTwitter />
                  </div>
                </div>
                <input
                  ref={input => (this.input = input)}
                  /* tslint:disable-next-line:max-line-length */
                  value={`https://${pageData.subdomain}.cian.ru/${pageData.dealType}/${pageData.offerType}/${pageData.offerId}`}
                  className={styles['input_link']}
                  disabled
                />
                {// tslint:disable-next-line:strict-type-predicates
                typeof document !== 'undefined' && (
                  <div className={styles['copy_link']} onClick={this.handleCopyLink}>
                    Скопировать ссылку
                  </div>
                )}
              </Popup>
            </OutsideClick>
          )}
        </div>
      </div>
    );
  }

  private handleClickOnSharingMainButton = () => {
    trackClickOnSharingMainButton();
    this.openPopup();
  };

  private openPopup = () => {
    this.setState({
      isOpenPopup: true,
    });
  };

  private closePopup = () => {
    this.setState({
      isOpenPopup: false,
    });
  };

  private handleCopyLink = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    trackClickOnSharingButton('copy_link');

    if (this.input) {
      this.input.disabled = false;
      this.input.select();

      try {
        document.execCommand('copy');
        this.input.disabled = true;
      } catch (e) {}
    }
  };

  private handleSocialLink = (e: React.MouseEvent<HTMLDivElement>, socialType: string) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    const { offerData, pageData, title } = this.props;
    let url: string | undefined;

    const link = `https://${pageData.subdomain}.cian.ru/${pageData.dealType}/${pageData.offerType}/${pageData.offerId}`;
    const utmMarked = `?utm_medium=social_repost&utm_campaign=card_social_repost&utm_source=${socialType}`;
    const description = getGeoLabel(offerData.offer);
    const image =
      offerData.offer && offerData.offer.photos && offerData.offer.photos.length > 0
        ? offerData.offer.photos[0].fullUrl
        : '';

    trackClickOnSharingButton(socialType);

    switch (socialType) {
      case 'vk':
        url = [
          `https://vk.com/share.php?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent(title)}`,
          `description=${encodeURIComponent(description)}`,
          `image=${encodeURIComponent(image)}`,
          `noparse=true`,
        ].join('&');
        break;

      case 'ok':
        url = [
          `https://connect.ok.ru/offer?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent(title)}`,
        ].join('&');
        break;

      case 'twitter':
        url = [
          `https://twitter.com/intent/tweet?url=${encodeURIComponent(link + utmMarked)}`,
          `text=${encodeURIComponent(title)}`,
        ].join('&');
        break;

      case 'facebook':
        url = [
          `https://www.facebook.com/v2.5/dialog/share?app_id=681114281993063`,
          `description=${encodeURIComponent(description)}`,
          `display=popup`,
          `href=${encodeURIComponent(link + utmMarked)}`,
          `locale=en_US`,
          `picture=${encodeURIComponent(image)}`,
          `sdk=joey`,
          `title=${encodeURIComponent(title)}`,
          `version=v2.5`,
        ].join('&');
        break;

      default:
        return;
    }

    const popupWidth = 800;
    const popupHeight = 600;
    const popupTopPosition = (window.outerHeight - popupHeight) / 2;
    const popupLeftPosition = (window.outerWidth - popupWidth) / 2;

    // tslint:disable-next-line:max-line-length
    const popupParams = `width=${popupWidth}, height=${popupHeight}, scrollbars=0, top=${popupTopPosition}, left=${popupLeftPosition}`;

    window.open(url, '', popupParams);
  };
}
